import styled from "styled-components";

const PoweredByContainer = styled.span`
  color: ${props => props.color};
  margin-top: 10px;
`;

export { PoweredByContainer };
